import { RouterProvider } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { router } from '@/app/_lib/router';

export default function TanStackRouterProvider() {
  return (
    <>
      <RouterProvider router={router} />
      {process.env.NODE_ENV === 'development' && <TanStackRouterDevtools router={router} />}
    </>
  );
}
